// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select.form-control {
  min-width: 12rem;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .ck-editor__editable {
  min-height: 300px; 
}
.img-name {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 2;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.panel-body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2rem 1rem 0;
}

.white-text {
  color: rgb(255, 255, 255) !important;
}

.panel-table {
  overflow-x: auto;
}

.panel-table table {
  width: 100%;
  min-width: 500px; 
  table-layout: auto;
}

.panel-table th, .panel-table td {
  white-space: nowrap;
  text-align: left;
}

@media (max-width: 538px) {
  .panel-table {
      overflow-x: auto;
  }

  .panel-table table {
      min-width: 700px; 
      table-layout: fixed;
  }

  .panel-table th, .panel-table td {
      white-space: normal;
  }

  .panel-table .p-paginator {
      display: block;
      overflow-x: auto;
  }
}

@media (max-width: 768px) {
  .panel-table th, .panel-table td {
      padding: 0.5rem;
  }

  .panel-table table {
      font-size: 0.85rem;
  }
}

.panel-table .p-paginator {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.p-table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/ticket/ticketlist/ticketlist.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;MACI,gBAAgB;EACpB;;EAEA;MACI,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,cAAc;MACd,gBAAgB;EACpB;AACF;;AAEA;EACE;MACI,eAAe;EACnB;;EAEA;MACI,kBAAkB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC","sourcesContent":["select.form-control {\n  min-width: 12rem;\n}\n\n.filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n}\n::ng-deep .ck-editor__editable {\n  min-height: 300px; \n}\n.img-name {\n  position: absolute;\n  left: 10px;\n  top: 10px;\n  z-index: 2;\n  width: 80%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.panel-body {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  padding: 2rem 1rem 0;\n}\n\n.white-text {\n  color: rgb(255, 255, 255) !important;\n}\n\n.panel-table {\n  overflow-x: auto;\n}\n\n.panel-table table {\n  width: 100%;\n  min-width: 500px; \n  table-layout: auto;\n}\n\n.panel-table th, .panel-table td {\n  white-space: nowrap;\n  text-align: left;\n}\n\n@media (max-width: 538px) {\n  .panel-table {\n      overflow-x: auto;\n  }\n\n  .panel-table table {\n      min-width: 700px; \n      table-layout: fixed;\n  }\n\n  .panel-table th, .panel-table td {\n      white-space: normal;\n  }\n\n  .panel-table .p-paginator {\n      display: block;\n      overflow-x: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .panel-table th, .panel-table td {\n      padding: 0.5rem;\n  }\n\n  .panel-table table {\n      font-size: 0.85rem;\n  }\n}\n\n.panel-table .p-paginator {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.p-table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
